import client from './index'

const getData = (data) => client['api'].get(`user/students/all`, {params: data})
const store = (data) => client['api'].post(`user/students`, data)
const kaprodiStore = (data) => client['api'].post(`myusers`, data)
const uploadExcel = (data) => client['api'].post(`user/students/excel`, data, {"Content-Type": "multipart/form-data"})

const destroy = (id) => client['api'].delete(`myusers/${id}`)

export {
    getData,
    store,
    destroy,
    uploadExcel,
    kaprodiStore
}